import IconReport from "@mui/icons-material/Assessment";
import IconNewApplication from "@mui/icons-material/CreateNewFolder";
import IconAllApplications from "@mui/icons-material/FactCheck";
import IconUserRequests from "@mui/icons-material/GroupAdd";
import IconImportantDocuments from "@mui/icons-material/ImportContacts";
import IconLogout from "@mui/icons-material/Logout";
import IconUsers from "@mui/icons-material/PeopleAlt";
import IconMyApplications from "@mui/icons-material/Summarize";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../app/slices/authSlice";
import {
  fetchUserRequests,
  resetStateUsers,
} from "../../app/slices/usersSlice";
import { hasAccess } from "../../app/utils";
import ApplicationViewDialog from "../applications/ApplicationViewDialog";
import "./Dashboard.css";
import DashboardCard from "./components/DashboardCard.Comp";

const Dashboard = () => {
  const { list: userRequests } = useSelector(({ users }) => users.requests);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openMyApplications, setOpenMyApplications] = useState(false);
  const [requestsBadgeText, setRequestsBadgeText] = useState(null);

  //use effects
  useEffect(() => {
    //fetch user requests --> for badge counter
    if (hasAccess({ type: "path", resource: "/users/requests" })) {
      resetStateUsers(["requests"]);
      dispatch(fetchUserRequests({ STATUS: "P" }));
    }
  }, []);

  useEffect(() => {
    if (userRequests?.length > 0) {
      let _length = userRequests?.length;
      if (_length <= 99) {
        setRequestsBadgeText(`${_length}`);
      } else {
        setRequestsBadgeText(`99+`);
      }
    }
  }, [userRequests]);

  //methods
  const handleLogout = () => {
    dispatch(logout());
  };

  //builders
  const BuildCards = () => {
    return (
      <div className="flex-row flex-wrap" id="dashboard-card-wrapper">
        {hasAccess({ type: "name", resource: "NEW_APPLICATION" }) && (
          <DashboardCard
            title={"New Application"}
            onClick={() => {
              navigate("/applications/apply");
            }}
            icon={<IconNewApplication />}
          />
        )}
        {hasAccess({ type: "name", resource: "MY_APPLICATIONS" }) && (
          <DashboardCard
            title={"My Applications"}
            onClick={() => {
              setOpenMyApplications(true);
            }}
            icon={<IconMyApplications />}
          />
        )}
        {hasAccess({ type: "name", resource: "ALL_APPLICATIONS" }) && (
          <DashboardCard
            title={"All Applications"}
            onClick={() => {
              navigate("/applications");
            }}
            icon={<IconAllApplications />}
          />
        )}
        {hasAccess({ type: "name", resource: "VIEW_REQUESTS" }) && (
          <DashboardCard
            title={"Registration Requests"}
            onClick={() => {
              navigate("/users/requests");
            }}
            icon={<IconUserRequests />}
            badgeText={requestsBadgeText}
          />
        )}
        {hasAccess({ type: "name", resource: "VIEW_USERS" }) && (
          <DashboardCard
            title={"Portal Users"}
            onClick={() => {
              navigate("/users");
            }}
            icon={<IconUsers />}
          />
        )}
        {hasAccess({ type: "name", resource: "VIEW_REPORTS" }) && (
          <DashboardCard
            title={"Reports"}
            onClick={() => {
              navigate("/reports");
            }}
            icon={<IconReport />}
          />
        )}
        {hasAccess({ type: "name", resource: "VIEW_DOCS" }) && (
          <DashboardCard
            title={"Important Documents"}
            onClick={() => {
              navigate("/importantDocuments");
            }}
            icon={<IconImportantDocuments />}
          />
        )}
      </div>
    );
  };

  return (
    <>
      <div className="dashboard-body">
        <div className="mt-20 flex-row align-items-center justify-content-space-between">
          <div>
            <h1>Dashboard</h1>
          </div>
          <div className="icon-logout" onClick={handleLogout}>
            <IconLogout /> <div className="logout-txt">Logout</div>
          </div>
        </div>
        {BuildCards()}

        {openMyApplications && (
          <ApplicationViewDialog
            open={openMyApplications}
            handleClose={() => setOpenMyApplications(false)}
          />
        )}
      </div>
    </>
  );
};

export default Dashboard;
